import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import isArray from 'lodash/isArray';
import {hasRole, Permission} from '../../helpers/user';

const PrivateRoute = props => {
  const {
    component: Component,
    user,
    role,
    permission,
    globalOptions,
    globalActions,
    pageTitle,
    ...rest
  } = props;

  const render = props => {
    const suppProps = {
      user,
      globalActions,
      ...props,
      globalOptions,
      pageTitle,
    };

    if (role || permission) {
      const rolePass = role
        ? isArray(role)
          ? role.some(role => hasRole(user.roles, role))
          : hasRole(user.roles, role)
        : true;
      const permissionPass = permission
        ? Permission.isAllowed(permission, user.permissions)
        : true;

      return rolePass && permissionPass ? (
        <Component {...suppProps} />
      ) : (
        <Redirect to={'/404'} />
      );
    }

    return user.isLoggedIn ? (
      <Component {...suppProps} />
    ) : (
      <Redirect to={'/404'} />
    );
  };

  return <Route {...rest} render={props => render(props)} />;
};

export default PrivateRoute;
